import { Environments } from '@innovyze/lib_get_service';

const config: any = {
  // Point browser at the agent on your machine (make run-local, port 80).
  // Without this, LOCAL still uses CloudOS and T&C/chat never hit your local agent.
  [Environments.LOCAL]: {
    w3fAgentServer: 'http://localhost',
  },
};

export const apiEnv =
  (localStorage.getItem('apiEnv') as keyof typeof Environments) || undefined;

export default config;
